import { ClinicInfo } from './types';
import { API_CONFIG } from '@/config/envConfig';

export const CLINIC_INFO: ClinicInfo = {
  callerId: 193184,
  hccId: 2,
  clinicName: 'HBox Internal',
  timezone: 'US/Pacific',
  clinicNumbers: ['6232952456', '+18009876543'],
  clinicNumbersSources: ['Twillio', 'Ported', 'Clinic']
};

export { 
  API_CONFIG,
  TWILIO_TOKEN_ENDPOINT,
  TWILIO_BLIND_TRANSFER_ENDPOINT,
  TWILIO_WARM_TRANSFER_ENDPOINT,
  PEP_V2_API_BASE
} from '@/config/envConfig';

export const GRAPHQL_ENDPOINT = API_CONFIG.GRAPHQL_ENDPOINT;

export const DEVICE_OPTIONS = {
  allowIncomingWhileBusy: false,
  closeProtection: true,
  enableImprovedSignalingErrorPrecision: true,
  logLevel: 1, // Changed from 4 (DEBUG) to 1 (ERROR only) to reduce logs
  maxCallSignalingTimeoutMs: 5000,
};